/* eslint-disable camelcase */

import { ArchiveDeleteResponse } from "components/common/ArchiveDialog/ArchiveDialog";
import { SWRConfiguration } from "swr";
import { ApiArrayResponse, ApiResponse, ServerResponse } from "./axiosConfig";
import { useSwr, axiosInst } from "./axiosWIS";

export interface LinkedIncidentTypes extends Record<string, unknown> {
  inc_type_name: string;
  incident_count: number;
  pk_inc_type_id: number;
}

export interface Sop extends Record<string, unknown> {
  pk_sop_template_id: number;
  sop_name: string;
  sop_desc: string;
  sop_exe_order_id: 0;
  sop_steps: SopStep[];
  linked_incident_types: LinkedIncidentTypes[];
}

export interface ArchiveSOPResponse extends ArchiveDeleteResponse<number> {
  detail: {
    succeed: number[];
    failed: number[];
  };
}

const baseKey = "/api/SopDefs";

export const useSops = (
  params: {
    pageNr?: number;
    pageSize?: number;
    orderBy?: string;
    Order?: string;
    SearchKey?: string;
  } = {
    pageNr: 1,
    pageSize: undefined,
    orderBy: undefined,
    Order: "desc",
    SearchKey: undefined,
  },
  config?: SWRConfiguration,
  requestBody?: Record<string, unknown>,
  filter?: boolean
): ServerResponse<ApiArrayResponse<Sop>> =>
  useSwr<ApiArrayResponse<Sop>>(
    `${baseKey}${filter ? "/filter" : ""}?pageNr=${params.pageNr}${
      params.pageSize ? `&pageSize=${params.pageSize}` : ""
    }
    ${
      params.orderBy != null
        ? `&orderBy=${params.orderBy}&Order=${params.Order}`
        : ""
    }
  ${params.SearchKey != null ? `&SearchKey=${params.SearchKey}` : ""}`,
    config,
    requestBody
  );

export const useSop = (
  id: string,
  config?: SWRConfiguration
): ServerResponse<ApiResponse<Sop>> =>
  useSwr<ApiResponse<Sop>>(`${baseKey}/${id}`, config);

export const addSop = async (data: Partial<Sop>): Promise<ApiResponse<Sop>> => {
  const res = await axiosInst.post(baseKey, data);
  return res.data;
};

export const editSop = async (
  data: Partial<Sop>
): Promise<ApiResponse<Sop>> => {
  const res = await axiosInst.put(`${baseKey}/${data.id}`, data);
  return res.data;
};

export const archiveSOP = async (id: string): Promise<ArchiveSOPResponse> => {
  const res = await axiosInst.delete(baseKey, { data: [id] });
  return res.data;
};
